
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["deptConfig_svg__icon",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 1024 1024","xmlns":"http://www.w3.org/2000/svg","width":"128","height":"128"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M385.5 667.6h136V566.1h-136v101.5zm136-270.7h-136v101.5h136V396.9zm-203 0h-136v101.5h136V396.9zm0-171.2h-136v101.5h136V225.7zm-136 441.9h136V566.1h-136v101.5zm339-441.9h-136v101.5h136V225.7zm268.1 272.7V396.9h-67v101.5h67zM113.5 872.6V122.2h473.1v533.2c16.6-33.3 40.1-62.6 69-86.1V327.2h203v187.7c23.2 3.7 45.7 10.6 67 20.5V259.6h-270v-205H46.5v818H13v67.7h605.9c-16.8-20.4-30.5-43.2-40.5-67.7H113.5zm846-145c-3.5-13-8.6-25.6-15.3-37.3l29.1-44.3h-.1l-41.3-41.7-43.9 29.3c-11.6-6.8-24-11.9-36.9-15.4l-10.5-52H782l-10.5 52c-12.9 3.5-25.3 8.7-36.9 15.4l-43.9-29.3-41.3 41.7 29.1 44.3c-6.7 11.7-11.8 24.2-15.3 37.3l-51.5 10.5v59.2l51.5 10.6c3.5 13 8.6 25.6 15.3 37.3l-29 44.3v.1l41.3 41.7v.1l43.9-29.4c11.6 6.8 24 11.9 36.9 15.4l10.5 52.1h58.6l10.5-52.1c12.9-3.5 25.3-8.7 36.9-15.4l43.9 29.4v-.1l41.3-41.7.1-.1-29.1-44.3c6.7-11.7 11.8-24.2 15.3-37.3l51.5-10.6v-59.2l-51.6-10.5zM811.3 837.8c-38.3 0-69.4-31.3-69.4-70s31.1-70 69.4-70c38.3 0 69.3 31.3 69.3 70 0 38.6-31 70-69.3 70zm0 0"}})])
          )
        }
      }
    